import { FC, createElement } from "react";

import { ReportSectionFieldsType, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { ReportField } from "@components/ReportField/ReportField";
import { getStructuralReportField } from "@components/ReportField/registry";

/**
 * Picks the renderer for a report field: structural field types (e.g. TreatmentPlan) render
 * their own complete UI directly; every other field type renders through ReportField. Callers
 * own the "add content" affordance (useCanAddContent + ReportFieldAddContent) around this.
 */
export const ReportFieldRenderer: FC<{
  section: ReportSectionsType;
  field: ReportSectionFieldsType;
  variant?: "ghost";
  disabled?: boolean;
}> = ({ field, section, variant, disabled }) => {
  const structuralField = getStructuralReportField(field.fieldType);
  if (structuralField) {
    return createElement(structuralField, { field, section });
  }

  return <ReportField field={field} section={section} variant={variant} disabled={disabled} />;
};
